import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class EquityLearnerDocumentGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isEquityUser) {
      return true;
    }
    this.router.navigate(['/unauthorized']);
    return false;
  }
}

@Injectable({ providedIn: 'root' })
export class EquityCreateCapGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isSuperAdmin || this.authService.isEquityStateAdministrator) {
      return true;
    }
    this.router.navigate(['/unauthorized']);
    return false;
  }
}
